module.exports = __webpack_public_path__ + "static/media/vector-left.b58a4640.svg";